export default "__VITE_ASSET__De$y6p29__"